import React from 'react'
import PropTypes from 'prop-types'
import ArrowUpward from 'material-ui/svg-icons/navigation/arrow-upward'
import ArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward'

const iconStyles = {
  height: '16px',
  width: '16px',
  marginLeft: '3px',
}

const SortDirectionArrow = ({ asc }) => (
  asc ? <ArrowDownward style={iconStyles} /> : <ArrowUpward style={iconStyles} />
)

SortDirectionArrow.propTypes = {
  asc: PropTypes.bool.isRequired,
}

export default SortDirectionArrow



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/Header/SortDirectionArrow.js